import React from 'react';
import { SmartphoneIcon, CheckIcon } from 'lucide-react';
import { instantAccess } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function InstantAccess() {
  return <section className="w-full bg-ink-950 px-4 py-14 sm:py-20" data-id="element-172" data-mp="39bdpjn6p1g9g">
      <div className="mx-auto max-w-2xl" data-id="element-173" data-mp="39dztzdyaffng">
        <p className="flex items-center justify-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.25em] text-arc-400" data-id="element-174" data-mp="34dlnw1g8yfs2">
          <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="30cryt4r2iuxl" />
          Accès immédiat
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-176" data-mp="2vj7ak4fa1fbl">
          Que recevrez-vous instantanément ?
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-177" data-mp="2lnng7mgd2ooy">
          {instantAccess.map(item => <li key={item} className="flex items-start gap-3" data-id="element-178" data-mp="2gnhne2ycuw5a">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-spark-500" data-id="element-179" data-mp="2clmk4swv68ov">
                <CheckIcon className="h-3 w-3 text-ink-950" aria-hidden="true" data-id="element-180" data-mp="35o6mmtamv3gv" />
              </span>
              <span className="text-[15px] leading-snug text-white/80" data-id="element-181" data-mp="3afx1nckimfem">{item}</span>
            </li>)}
        </ul>

        <div className="mt-7 rounded-2xl border-l-4 border-arc-500 bg-ink-800/70 p-5" data-id="element-182" data-mp="2vrk62gpcaykn">
          <p className="text-[15px] leading-relaxed text-white/80" data-id="element-183" data-mp="30otxg1wahkb4">
            Chaque fois que vous avez un doute dans l’atelier, ouvrez le manuel
            correspondant et trouvez la réponse en quelques minutes.
          </p>
          <p className="mt-3 text-[15px] font-bold text-spark-400" data-id="element-184" data-mp="3tdhralv3ti0a">
            Tout cela depuis votre téléphone, avec un paiement unique.
          </p>
        </div>

        <div className="mt-9" data-id="element-185" data-mp="3jfbnfypqm1ss">
          <CtaBlock label="Je veux le Système Maître" data-id="element-186" data-mp="3jea2n2ix60xv" />
        </div>
      </div>
    </section>;
}